import React from "react";
import shallowequal from "shallowequal";
import filter from "../../filter";
import {executeQuery} from "../../requests/executeQuery";
import dollars from '../../dollar-format';
import {percent, renderPrintFooter} from '../../utils';
import arrowRed from "../../svgs/arrow-red.svg";
import arrowGreen from "../../svgs/arrow-green.svg";
import {TEXAS_MARKET_TRANSACTIONS} from '../../consts/queries';

const rows = [{
    name: 'No. of Transactions',
    key: 'COUNT'
}, {
    name: 'Ave Price',
    key: 'PRICE',
    formatType: '$',
}, {
    name: 'Ave Cap Rate',
    key: 'CAP_RATE',
    formatType: '%',
}, {
    name: 'Ave Cap Rate at List',
    key: 'LIST_CAP_RATE',
    formatType: '%',
}, {
    name: 'Delta (List to Sell)',
    key: 'DELTA_LIST_TO_SELL',
    formatType: '%',
}, {
    name: 'Ave PSF',
    key: 'PRICE_PSF',
    formatType: '$',
}, {
    name: 'Ave Rent PSF',
    key: 'RENT_PSF',
    formatType: '$',
}, {
    name: 'Occupancy',
    key: 'OCCUPANCY',
    formatType: '%',
}];

export default class MarketTransactionBreakdown extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            query: {},
            year: null,
            previousYear: null,
            transactions: {
                STNL: {},
                MT: {}
            },
            isPrint: false,
            printBackground: '',
        };

        this.beforePrint = this.beforePrint.bind(this);
        this.afterPrint = this.afterPrint.bind(this);
    }

    static formatValue({data, key, formatType}) {
        let value = data[key] || 0;
        let valuePrevYear = data[`${key}_PREV_YEAR`] || 0;
        let delta = data[`${key}_DELTA`] || 0;
        if (delta < 0) delta = Math.abs(delta).toString();
        let deltaPercent = data[`${key}_DELTA_PERCENT`] ? Math.round(data[`${key}_DELTA_PERCENT`]) : 0;

        switch (formatType) {
            case '$': {
                value = dollars(value);
                valuePrevYear = dollars(valuePrevYear);
                delta = dollars(delta);
                break;
            }
            case '%': {
                if (key === 'DELTA_LIST_TO_SELL') {
                    if (parseFloat(value) < 0) value = Math.abs(value);
                    value = percent(value);
                    if (parseFloat(valuePrevYear) < 0) valuePrevYear = Math.abs(valuePrevYear);
                    else valuePrevYear = percent(valuePrevYear);
                } else {
                    value = percent(value);
                    valuePrevYear = percent(valuePrevYear);
                    delta = percent(delta);
                }
                break;
            }
        }

        if (deltaPercent < 0) deltaPercent = Math.abs(deltaPercent).toString();
        deltaPercent = percent(deltaPercent, false);

        if (key === 'DELTA_LIST_TO_SELL')
            return {value, valuePrevYear, delta: '', deltaPercent: ''};

        return {value, valuePrevYear, delta, deltaPercent};
    }

    static buildTableData({data, dataPrevYear, type}) {
        const transactions = {};
        rows.forEach(row => {
            if (type === 'STNL' && row.key === 'OCCUPANCY') return;

            let value = data[row.key] || 0;
            let valuePrevYear = dataPrevYear[row.key] || 0;
            let delta = data[row.key] - dataPrevYear[row.key] || 0;

            if (['COUNT', 'PRICE'].includes(row.key))  {
                value = parseInt(value);
                valuePrevYear = parseInt(valuePrevYear);
                delta = parseInt(delta);
            }

            transactions[row.key] = value;
            transactions[`${row.key}_PREV_YEAR`] = valuePrevYear;

            if (row.key !== 'DELTA_LIST_TO_SELL') {
                transactions[`${row.key}_DELTA`] = delta;
                transactions[`${row.key}_DELTA_PERCENT`] = valuePrevYear ? (value - valuePrevYear) / valuePrevYear * 100 : value * 100;
            }
        });
        return transactions;
    }

    componentDidMount() {
        this.setState({printBackground: `url('${arc.path.media+'Transaction_Background.png'}')`});
        this.fetch(this.props.location.query);
        window.history.replaceState(null, '');
        window.onbeforeprint = this.beforePrint;
        window.onafterprint = this.afterPrint;
    }

    componentDidUpdate(prevProps) {
        if (!shallowequal(prevProps.location.query, this.props.location.query)) {
            this.fetch(this.props.location.query);
        }
    }

    beforePrint() {
        this.setState({isPrint: true});
    }

    afterPrint() {
        this.setState({isPrint: false});
    }

    fetch(q) {
        const query = {...q};
        const queryPrevYear = {...q};

        const today = new Date();
        let year = today.getFullYear().toString(), prevYear = year - 1;
        if (query.TRANSACTION_YEAR) {
            year = query.TRANSACTION_YEAR;
            prevYear = (year - 1).toString();
            queryPrevYear.TRANSACTION_YEAR = prevYear;
        } else {
            year = '';
            prevYear = '';
        }

        const optionsSTNL = filter({...query, TYPE: 'STNL'}, 'market-transaction-breakdown');
        const optionsPrevYearSTNL = filter({...queryPrevYear, TYPE: 'STNL'}, 'market-transaction-breakdown');
        const optionsMT = filter({...query, TYPE: 'MT'}, 'market-transaction-breakdown');
        const optionsPrevYearMT = filter({...queryPrevYear, TYPE: 'MT'}, 'market-transaction-breakdown');

        const requests = [
            executeQuery({queryName: TEXAS_MARKET_TRANSACTIONS, options: optionsSTNL}),
            executeQuery({queryName: TEXAS_MARKET_TRANSACTIONS, options: optionsPrevYearSTNL}),
            executeQuery({queryName: TEXAS_MARKET_TRANSACTIONS, options: optionsMT}),
            executeQuery({queryName: TEXAS_MARKET_TRANSACTIONS, options: optionsPrevYearMT}),
        ];

        Promise.all(requests).then(res => {
            if (res && res[0] && res[0].data && Array.isArray(res[0].data) &&
                res[1] && res[1].data && Array.isArray(res[1].data) &&
                res[2] && res[2].data && Array.isArray(res[2].data) &&
                res[3] && res[3].data && Array.isArray(res[3].data)) {

                const transactions = [];
                transactions.STNL = MarketTransactionBreakdown.buildTableData({data: res[0].data[0], dataPrevYear: res[1].data[0], type: 'STNL'});
                transactions.MT = MarketTransactionBreakdown.buildTableData({data: res[2].data[0], dataPrevYear: res[3].data[0], type: 'MT'});

                this.setState({
                    query,
                    year: year,
                    previousYear: prevYear,
                    transactions,
                });
                return;
            }
            this.setState({
                query,
                year: year,
                previousYear: prevYear,
            });
        });
    }

    static renderMarketTable({data, type, market, previousYear, year}) {
        return (
            <React.Fragment>
                <div className='texas-market-title'>{type} Type</div>
                <div className='texas-market-subtitle'>TRANSACTIONS IN {market ? market.toUpperCase() : ''}</div>
                <table className='texas-market-table'>
                    <thead>
                    <tr className='texas-market-tr'>
                        <th className='texas-market-th'/>
                        <th className='texas-market-th'>{previousYear}</th>
                        <th className='texas-market-th'>{year}</th>
                        <th className='texas-market-th'>Delta</th>
                        <th className='texas-market-th'>% △</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        rows.map((row, index) => {
                            if (type === 'Single-Tenant' && row.key === 'OCCUPANCY') return;

                            const {value, valuePrevYear, delta, deltaPercent} = data ? MarketTransactionBreakdown.formatValue({data, key: row.key, formatType: row.formatType}) : '';
                            const negative = data[`${row.key}_DELTA`] < 0;

                            return (
                                <tr key={index} className='texas-market-tr'>
                                    <td className={`texas-market-td ${index % 2 ? 'second-color' : ''}`}>{row.name}</td>
                                    <td className={`texas-market-td ${index % 2 ? 'second-color' : ''}`}>{valuePrevYear}</td>
                                    <td className={`texas-market-td ${index % 2 ? 'second-color' : ''}`}>{value}</td>
                                    <td className={`texas-market-td ${index % 2 ? 'second-color' : ''} ${negative ? 'red' : 'green'}`}>{delta}</td>
                                    <td className={`texas-market-td ${index % 2 ? 'second-color' : ''} ${negative ? 'red' : 'green'}`}>
                                        {
                                            deltaPercent &&
                                            <div className='texas-market-delta-percent'>
                                                {deltaPercent}
                                                <div className={negative ? 'arrow-red' : 'arrow-green'} dangerouslySetInnerHTML={{__html: negative ? arrowRed : arrowGreen}}/>
                                            </div>
                                        }
                                    </td>
                                </tr>
                            )
                        })
                    }
                    </tbody>
                </table>
            </React.Fragment>
        )
    }

    render() {
        const {query, transactions, year, previousYear, isPrint, printBackground} = this.state;

        return (
            <div className='MarketTransactionBreakdown'>
                <div className='print-container' style={{backgroundImage: isPrint && printBackground}}>
                    {MarketTransactionBreakdown.renderMarketTable({data: transactions.MT, type: 'Multi-Tenant', market: query.MARKET, year, previousYear})}
                    {renderPrintFooter(isPrint)}
                </div>
                <div className='print-container' style={{backgroundImage: isPrint && printBackground}}>
                    {MarketTransactionBreakdown.renderMarketTable({data: transactions.STNL, type: 'Single-Tenant', market: query.MARKET, year, previousYear})}
                    {renderPrintFooter(isPrint)}
                </div>
                <div className='preload-print-background' style={{backgroundImage: printBackground}}/>
            </div>
        )
    }
}